import React from 'react';
import { smoothScroll } from '@doda/common/src/utils/animationUtil';
import { LABEL_NAME } from '@doda/common/src/constants/seo/jobTrendConstants';
import styles from './index.module.scss';

export const AnchorLink: React.FC = () => {
  const scrollAnchorLink = (id: string) => {
    const offsetTop = document.getElementById(id)?.offsetTop || 0;
    // ページ内スクロール
    smoothScroll(offsetTop);
  };
  return (
    <div className={styles.AnchorLinkWrapper}>
      <h2>カテゴリごとの求人数を見る</h2>
      <ul>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-requirements')}
          >
            {LABEL_NAME.REQUIREMENT}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-income')}
          >
            {LABEL_NAME.INCOME}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-workplace-environment')}
          >
            {LABEL_NAME.WORKPLACE_ENVIRONMENT}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-holiday-and-way-of-working')}
          >
            {LABEL_NAME.HOLIDAY_AND_WAY_OF_WORKING}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-employee-average-age')}
          >
            {LABEL_NAME.EMPLOYEE_AVERAGE_AGE}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-employmment-status')}
          >
            {LABEL_NAME.EMPLOYMMENT_STATUS}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-welfare-benefits')}
          >
            {LABEL_NAME.WELFARE_BENEFITS}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-language-and-positions')}
          >
            {LABEL_NAME.LANGUAGE_AND_POSITIONS}
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => scrollAnchorLink('index-establish')}
          >
            設立
          </button>
        </li>
      </ul>
    </div>
  );
};
